(() => {
  if (window.zenyumStudentPageInitialized) return;
  window.zenyumStudentPageInitialized = true;
  function setPriceMode(root, monthly) {
    const control=root.querySelector('#price-mode-switch'); if(!control) return;
    control.setAttribute('aria-checked',String(monthly));
    root.querySelectorAll('[data-price-view]').forEach(p=>p.hidden=p.dataset.priceView!==(monthly?'monthly':'total'));
    ['total','monthly'].forEach(mode=>{const b=root.querySelector('#'+mode+'-mode-label'); if(b){b.classList.toggle('is-selected',mode===(monthly?'monthly':'total'));b.setAttribute('aria-pressed',String(mode===(monthly?'monthly':'total')));}});
    const status=root.querySelector('#price-mode-status');if(status)status.textContent=monthly?(status.getAttribute('data-monthly-status')||'現正顯示按學生優惠價估算的 24 個月每月分期金額。'):(status.getAttribute('data-total-status')||'現正顯示已扣除 HK$3,000 的學生牙套方案優惠價。');
  }
  function activate(root,tab,focus) {
    root.querySelectorAll('[role="tab"]').forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;const panel=root.querySelector('#'+t.getAttribute('aria-controls'));if(panel)panel.hidden=!active;});
    if(focus)tab.focus();
  }
  document.addEventListener('click',event=>{
    const button=event.target.closest('button');if(!button)return;
    const root=button.closest('[data-zenyum-root]');if(!root)return;
    if(button.matches('[role="tab"]'))activate(root,button,false);
    if(button.id==='price-mode-switch')setPriceMode(root,button.getAttribute('aria-checked')!=='true');
    if(button.id==='total-mode-label')setPriceMode(root,false);
    if(button.id==='monthly-mode-label')setPriceMode(root,true);
  });
  document.addEventListener('keydown',event=>{
    const tab=event.target.closest('[data-zenyum-root] [role="tab"]');if(!tab)return;
    const root=tab.closest('[data-zenyum-root]'),tabs=[...root.querySelectorAll('[role="tab"]')],i=tabs.indexOf(tab);
    const next=event.key==='ArrowRight'?tabs[(i+1)%tabs.length]:event.key==='ArrowLeft'?tabs[(i-1+tabs.length)%tabs.length]:event.key==='Home'?tabs[0]:event.key==='End'?tabs[tabs.length-1]:null;
    if(next){event.preventDefault();activate(root,next,true);}
  });
  document.addEventListener('shopify:section:load',event=>{
    const root=event.target.querySelector('[data-zenyum-root]');if(!root)return;
    setPriceMode(root,false);const tab=root.querySelector('[role="tab"]');if(tab)activate(root,tab,false);
  });
})();

(() => {
  'use strict';
  if (window.zenyumStudentAttributionInitialized) return;
  window.zenyumStudentAttributionInitialized = true;
  const allowed = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','gclid','dclid','fbclid','msclkid','wbraid','gbraid'];
  function updateLinks(scope) {
    const incoming = new URLSearchParams(window.location.search);
    scope.querySelectorAll('a[href]').forEach(link => {
      let url;
      try { url = new URL(link.getAttribute('href'), window.location.href); } catch (_) { return; }
      if (url.origin !== 'https://obt3.zenyum.com' || url.pathname !== '/hk-zh/intro') return;
      allowed.forEach(key => {
        const value = incoming.get(key);
        if (value && !url.searchParams.has(key)) url.searchParams.set(key, value);
      });
      link.setAttribute('href', url.href);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => updateLinks(document), {once:true});
  else updateLinks(document);
  document.addEventListener('shopify:section:load', event => updateLinks(event.target));
})();
